import Roles from "../../constants/roles";
import { useAppSelector } from "../../hooks";

const IsAuthorizedRole = (roles: Roles[]) => {
  const userRoles = useAppSelector((state) => state.authSlice.roles);

  return (
    userRoles &&
    userRoles.length > 0 &&
    roles.some((role) => userRoles.includes(role))
  );
};

const AuthorizeHelper = {
  IsAuthorizedRole,
};

export default AuthorizeHelper;
